/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
		  $(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');
		$('.masthead').toggleClass('expanded');
		$('body').toggleClass('state--mobile-nav-open');
	});

	var transparentNav = $('.masthead').hasClass('transparent-nav');

	$(window).scroll(function(){
	  var offset = 0;
		var top = $(window).scrollTop();

		if (top > 0) {
			if (transparentNav) {
				$('.masthead').removeClass('transparent-nav');
			}
		}
		else {
			if (transparentNav) {
				$('.masthead').addClass('transparent-nav');
			}
		}

	});
});
